import { render, staticRenderFns } from "./sidebar_confidentiality_content.vue?vue&type=template&id=645a8b2c&vue3"
import script from "./sidebar_confidentiality_content.vue?vue&type=script&lang=js&vue3"
export * from "./sidebar_confidentiality_content.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports